import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ApprovalFlow, ApprovalFlowInput, filteringApproval} from './approval-flow.model';

export const loadApprovalFlows = createAction(
  '[ApprovalFlow/API] Load ApprovalFlows',
  props<{ approvalFlows: ApprovalFlow[] }>()
);

export const addApprovalFlow = createAction(
  '[ApprovalFlow/API] Add ApprovalFlow',
  props<{ approvalFlow: ApprovalFlow }>()
);

export const upsertApprovalFlow = createAction(
  '[ApprovalFlow/API] Upsert ApprovalFlow',
  props<{ approvalFlow: ApprovalFlow }>()
);

export const addApprovalFlows = createAction(
  '[ApprovalFlow/API] Add ApprovalFlows',
  props<{ approvalFlows: ApprovalFlow[] }>()
);

export const upsertApprovalFlows = createAction(
  '[ApprovalFlow/API] Upsert ApprovalFlows',
  props<{ approvalFlows: ApprovalFlow[] }>()
);

export const updateApprovalFlow = createAction(
  '[ApprovalFlow/API] Update ApprovalFlow',
  props<{ approvalFlow: Update<ApprovalFlow> }>()
);

export const updateApprovalFlows = createAction(
  '[ApprovalFlow/API] Update ApprovalFlows',
  props<{ approvalFlows: Update<ApprovalFlow>[] }>()
);

export const deleteApprovalFlow = createAction(
  '[ApprovalFlow/API] Delete ApprovalFlow',
  props<{ id: string }>()
);

export const deleteApprovalFlows = createAction(
  '[ApprovalFlow/API] Delete ApprovalFlows',
  props<{ ids: string[] }>()
);

export const clearApprovalFlows = createAction(
  '[ApprovalFlow/API] Clear ApprovalFlows'
);


// CUSTOM //


export const getAllProcessApprovalFlows = createAction(
  '[ApprovalFlow/API] get All Process Approval Flows',
  props<{ filtering?:filteringApproval  }>()
);

export const createApprovalFlowMutation = createAction(
  '[ApprovalFlow/API] create Approval Flow Mutation',
  props<{ flow?:ApprovalFlowInput  }>()
);

export const updateApprovalFlowMutation = createAction(
  '[ApprovalFlow/API] create Approval Update Approval Flow Mutation',
  props<{ flow?:ApprovalFlowInput  }>()
);


export const removeApprovalFlowMutation = createAction(
  '[ApprovalFlow/API] delete Approval Flow Mutation',
  props<{ flowUniqueId:string,id:string  }>()
);








// ng g entity store/entities/citizens/citizens-free-services-summaries  --reducers ../../reducers/index.ts --flat false --skip-tests true
// ng g effect store/entities/citizens/citizens-free-services-summaries --root  -m app.module.ts --flat false --skip-tests true
// ng g selector store/entities/citizens/citizens-free-services-summaries --flat  false --skip-tests true



